/**
 * Darstellung der Kreditkarten. Eigene Datei neben format.ts, damit die
 * Kontoauszuege unberuehrt bleiben.
 *
 * Auf der Karte heisst ein Saldo "Schuld" oder "Guthaben", nie Minus: in der
 * Datenbank steht die Schuld negativ (aus Sicht des Karteninhabers), gezeigt
 * wird sie wie auf der Abrechnung.
 */
import { euro } from './format'
import type { Kartenklasse, SaldoArt } from './api'

/**
 * Versuch seit 30.09.2026 (Vorschlag Schuett): Karten gehen nur als camt.053
 * mit Ersatz-IBAN nach DATEV, wie ein Bankkonto. Buchungsstapel, Beraternummer,
 * Kartenkonto und Gegenkonto sind dann ausgeblendet. Der Code dafuer bleibt,
 * false holt alles zurueck.
 */
export const NUR_CAMT = true

/** Platzhalter fuer ein leeres Feld, derselbe wie in format.ts (euro, datum). Kein Satzzeichen. */
export const LEER = '\u2014'

/** "Schuld 1.482,17 €", "Guthaben 20,00 €", "0,00 €". */
export function saldoWort(cent: string | bigint | null | undefined): string {
  if (cent === null || cent === undefined || cent === '') return LEER
  const wert = typeof cent === 'bigint' ? cent : BigInt(cent)
  if (wert === 0n) return '0,00 €'
  return `${wert < 0n ? 'Schuld' : 'Guthaben'} ${euro(wert < 0n ? -wert : wert)} €`
}

/** Betrag ohne Vorzeichen fuer ein Eingabefeld: "1.234,56". */
export function betragOhneZeichen(cent: string | null | undefined): string {
  if (cent === null || cent === undefined || cent === '') return ''
  return euro(cent).replace('−', '')
}

/** Die Bedeutung eines gespeicherten Saldos: aus dem Vorzeichen, sonst aus der gelesenen Art. */
export function saldoArtAus(cent: string | null, art: SaldoArt | null): SaldoArt | null {
  if (cent !== null && cent !== '') {
    const wert = BigInt(cent)
    if (wert < 0n) return 'schuld'
    if (wert > 0n) return 'guthaben'
  }
  return art
}

/** Die letzten vier Ziffern, wie sie in Listen stehen: "···· 1009". */
export function endeKurz(endziffern: string | null | undefined): string {
  return endziffern ? `···· ${endziffern}` : ''
}

export const KLASSE_TEXT: Record<Kartenklasse, string> = {
  kauf: 'Kauf',
  bargeld: 'Bargeld',
  entgelt: 'Entgelt',
  zins: 'Zinsen',
  zahlung: 'Zahlung',
  gutschrift: 'Gutschrift',
  ruecklastschrift: 'Rücklastschrift',
  sonstig: 'Sonstiges',
}

export const KLASSEN = Object.keys(KLASSE_TEXT) as Kartenklasse[]

export const MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
